import React, { useEffect, useRef, useState } from "react";
import { animate } from "framer-motion";

export default function CountUp({
  value,
  duration = 0.4,
  format = (v) => Math.round(v).toString(),
  testId,
}) {
  const ref = useRef(null);
  const prev = useRef(0);
  const [display, setDisplay] = useState(format(value));

  useEffect(() => {
    const controls = animate(prev.current, value, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(format(v)),
    });
    prev.current = value;
    return () => controls.stop();
  }, [value, duration, format]);

  return (
    <span ref={ref} data-testid={testId}>
      {display}
    </span>
  );
}
